import React from 'react';
import styled from 'styled-components';

const ReviewsContainer = styled.section`
  padding: 4rem 2rem;
  background-color: #f8f9fa;
  text-align: center;
`;

const ReviewsTitle = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  color: #151b26;
  margin-bottom: 2rem;
`;

const ReviewsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const ReviewCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  text-align: left;
`;

const ReviewerInfo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
`;

const ReviewerAvatar = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #e0e0e0;
  margin-right: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: #151b26;
`;

const ReviewerName = styled.h3`
  font-size: 1.2rem;
  font-weight: 600;
  color: #151b26;
  margin: 0;
`;

const ReviewerLocation = styled.p`
  font-size: 0.9rem;
  color: #757575;
  margin: 0;
`;

const ReviewText = styled.p`
  font-size: 1rem;
  color: #333;
  line-height: 1.6;
`;

const Rating = styled.div`
  color: #ffc107;
  font-size: 1.2rem;
  margin-top: 1rem;
`;

const ReviewsSection = () => {
  // Sample reviews data
  const reviews = [
    {
      id: 1,
      name: "Alex Johnson",
      location: "New York, USA",
      text: "Skyline Backpackers provided an amazing experience! The dormitory was clean, the staff was friendly, and the location was perfect for exploring Hyderabad.",
      rating: 5
    },
    {
      id: 2,
      name: "Maria Garcia",
      location: "Madrid, Spain",
      text: "Great value for money. The beds were comfortable and the common areas were well-maintained. I would definitely stay here again during my travels.",
      rating: 4
    },
    {
      id: 3,
      name: "Raj Patel",
      location: "Mumbai, India",
      text: "Loved the atmosphere here. Met travelers from all over the world. The rooftop area offers a fantastic view of the city skyline!",
      rating: 5
    }
  ];

  // Function to render stars based on rating
  const renderStars = (rating) => {
    return '★'.repeat(rating) + '☆'.repeat(5 - rating);
  };

  return (
    <ReviewsContainer>
      <ReviewsTitle>What Our Guests Say</ReviewsTitle>
      <ReviewsGrid>
        {reviews.map(review => (
          <ReviewCard key={review.id}>
            <ReviewerInfo>
              <ReviewerAvatar>
                {review.name.charAt(0)}
              </ReviewerAvatar>
              <div>
                <ReviewerName>{review.name}</ReviewerName>
                <ReviewerLocation>{review.location}</ReviewerLocation>
              </div>
            </ReviewerInfo>
            <ReviewText>{review.text}</ReviewText>
            <Rating>{renderStars(review.rating)}</Rating>
          </ReviewCard>
        ))}
      </ReviewsGrid>
    </ReviewsContainer>
  );
};

export default ReviewsSection;
